import { render, staticRenderFns } from "./IntakeDash.vue?vue&type=template&id=3058d9d2&scoped=true&"
import script from "./IntakeDash.vue?vue&type=script&lang=js&"
export * from "./IntakeDash.vue?vue&type=script&lang=js&"
import style0 from "./IntakeDash.vue?vue&type=style&index=0&id=3058d9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3058d9d2",
  null
  
)

export default component.exports